var _path, _path2, _path3, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrustedByDoctors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M501.17 907.54l20-22.06q-10.1 1.46-20.33 2.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M512 3.22C267.66 3.22 69.59 201.3 69.59 445.63c0 237.11 186.52 430.64 420.84 441.89l1.87 98.77q-.06.93-.06 1.89a32.62 32.62 0 0032.6 32.6h.49a32.52 32.52 0 0025.26-12.61L695 848.52c153-69.63 259.37-223.83 259.37-402.89C954.41 201.3 756.34 3.22 512 3.22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M674.53 333L517 267.59a13.05 13.05 0 00-10 0L349.47 333a13 13 0 00-8.05 12.06v79.5a266.09 266.09 0 00165.64 246.51 13.06 13.06 0 009.88 0 266.12 266.12 0 00165.64-246.52v-79.5a13 13 0 00-8.05-12.05z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57.23,
    height: 159,
    x: 483.39,
    y: 374.04,
    fill: "#f9af17",
    rx: 10.75,
    ry: 10.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 57.23,
    height: 159,
    x: 483.39,
    y: 374.04,
    fill: "#f9af17",
    rx: 10.75,
    ry: 10.75,
    transform: "rotate(90 512 453.54)"
  })));
}

export default SvgTrustedByDoctors;